import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="w-full overflow-hidden" style={{ background: '#1a1a2e' }}>
      {/* Top links */}
      <div className="grid grid-cols-1 md:grid-cols-3 px-10 pt-16 pb-10 gap-8">
        <div>
          <p className="boldonse text-white text-xl mb-6 tracking-wide">NAVIGATION</p>
          {[
            { label: 'About Us', to: '/about' },
            { label: 'Our Services', to: '/services' },
            { label: 'Our Products', to: '/products' },
            { label: 'Contact Us', to: '/contact' },
          ].map((item) => (
            <Link
              key={item.label}
              to={item.to}
              className="block text-white/70 hover:text-white text-sm mb-3 transition-colors duration-300 tracking-wide"
            >
              {item.label}
            </Link>
          ))}
        </div>
        <div>
          <p className="boldonse text-white text-xl mb-6 tracking-wide">LEGAL</p>
          {[
            { label: 'Terms of Use', to: '/terms' },
            { label: 'Privacy Policy', to: '/privacy' },
            { label: 'Refund Policy', to: '/refund' },
          ].map((item) => (
            <Link
              key={item.label}
              to={item.to}
              className="block text-white/70 hover:text-white text-sm mb-3 transition-colors duration-300 tracking-wide"
            >
              {item.label}
            </Link>
          ))}
        </div>
        <div>
          <p className="boldonse text-white text-xl mb-6 tracking-wide">CONTACT</p>
          <p className="text-white/70 text-sm mb-2 leading-relaxed">
            Syntera Solutions LTD
          </p>
          <p className="text-white/50 text-sm mb-2 leading-relaxed">
            International House<br />
            64 Nile Street<br />
            London, N1 7SR<br />
            United Kingdom
          </p>
          <a
            href="mailto:help@syntera-solutions.com"
            className="block text-white/70 hover:text-[#F2CF59] text-sm mb-2 transition-colors duration-300"
          >
            help@syntera-solutions.com
          </a>
          <a
            href="tel:+447520640897"
            className="block text-white/70 hover:text-[#F2CF59] text-sm mb-2 transition-colors duration-300"
          >
            +44 7520 640897
          </a>
        </div>
      </div>

      {/* Divider */}
      <div className="mx-10 h-px bg-white/20" />

      {/* Big brand name */}
      <div className="px-6 py-8 overflow-hidden">
        <p
          className="boldonse text-[#F2CF59] select-none leading-none"
          style={{
            fontSize: 'clamp(60px, 12vw, 160px)',
            letterSpacing: '-4px',
            lineHeight: 0.85,
          }}
        >
          Syntera
        </p>
      </div>

      {/* Bottom bar */}
      <div className="flex flex-col sm:flex-row items-center justify-between px-10 pb-8 gap-4">
        <p className="text-white/40 text-xs">© 2026 Syntera Solutions LTD. All rights reserved.</p>
        <div className="flex gap-6">
          {[
            { label: 'Terms of Use', to: '/terms' },
            { label: 'Privacy Policy', to: '/privacy' },
            { label: 'Refund Policy', to: '/refund' },
          ].map((item) => (
            <Link
              key={item.label}
              to={item.to}
              className="text-white/40 hover:text-white text-xs transition-colors duration-300"
            >
              {item.label}
            </Link>
          ))}
        </div>
      </div>
    </footer>
  );
}